import React from 'react';
import { motion } from 'framer-motion';
const antes = [{
  bold: 'Te acostatás cansada',
  light: 'y aun así no descansatás.'
}, {
  bold: 'A media tarde necesitás',
  light: 'azúcar o café para seguir.'
}, {
  bold: 'Tu ropa ya no',
  light: 'se siente igual.'
}, {
  bold: 'Sentís que tu cuerpo cambió,',
  light: 'pero no entenés por qué.'
}];
const despues = [{
  bold: 'Despertás',
  light: 'con más energía.'
}, {
  bold: 'Tu cuerpo deja de sentirse',
  light: 'inflamado todo el día.'
}, {
  bold: 'Volvés a confiar',
  light: 'en las señales de tu cuerpo.'
}, {
  bold: 'Tenés una estrategia',
  light: 'para esta etapa.'
}];
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 8
  },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      delay: i * 0.09,
      ease: 'easeOut'
    }
  })
};
export function DifferenceSection() {
  return <section className="bg-gradient-section py-24 md:py-32 px-5 md:px-8" data-id="element-41" data-mp="2cruldf0rnhx4">
      <div className="max-w-2xl mx-auto" data-id="element-42" data-mp="2frnl9hacjfkm">

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center uppercase tracking-[0.28em] text-[#C8A870] mb-5" style={{
        fontSize: 11,
        fontFamily: 'sans-serif',
        fontWeight: 600
      }} data-id="element-43" data-mp="2fsp8ek4mzsip">
          La diferencia después de 21 días
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="text-center font-display font-semibold text-[#F0E8D8] leading-[1.05] mb-16 md:mb-20" style={{
        fontSize: 'clamp(34px, 7vw, 58px)'
      }} data-id="element-44" data-mp="2yq05by2sq9uz">
          Del agotamiento{' '}
          <span className="italic text-gradient-gold" data-id="element-45" data-mp="3hf6g8yxclx68">a la estrategia.</span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="grid grid-cols-[1fr_auto_1fr] gap-0" data-id="element-46" data-mp="3mdrj763ziuyd">
          {/* Columna ANTES */}
          <div data-id="element-47" data-mp="1w5qy7w6vg38u">
            <p className="uppercase tracking-[0.22em] text-[#F0E8D8]/30 mb-4 pb-3" style={{
            fontSize: 10,
            fontFamily: 'sans-serif',
            fontWeight: 600,
            borderBottom: '0.5px solid rgba(240,232,216,0.1)'
          }} data-id="element-48" data-mp="1w5h4bxiphbxv">
              Antes
            </p>
            <motion.ul initial="hidden" whileInView="visible" viewport={{
            once: true,
            amount: 0.2
          }} className="space-y-9" data-id="element-49" data-mp="2153hk6yjas6o">
              {antes.map((item, i) => <motion.li key={i} custom={i} variants={itemVariants} className="flex gap-2.5" data-id="element-50" data-mp="2a1ck3uht66x1" data-mpi={i}>
                  <span className="flex-shrink-0 text-[#C8A870]/50 mt-0.5 select-none" style={{
                fontSize: 14,
                lineHeight: 1.5,
                fontFamily: 'sans-serif'
              }} data-id="element-51" data-mp="kor54ycp9kdr">—</span>
                  <div data-id="element-52" data-mp="2wbuokcczkj6m">
                    <p className="font-body text-[#F0E8D8]/45 leading-[1.5]" style={{
                  fontSize: 'clamp(12px, 2.2vw, 14px)'
                }} data-id="element-53" data-mp="2wc45zbjyti0p">
                      <strong className="font-semibold text-[#F0E8D8]/55" data-id="element-54" data-mp="2hl3x55fb3m41">{item.bold}</strong>
                      <br data-id="element-55" data-mp="2mjyhwcwu3kqs" />{item.light}
                    </p>
                  </div>
                </motion.li>)}
            </motion.ul>
          </div>

          {/* Divisor central */}
          <div className="flex flex-col items-center" style={{
          width: 56,
          paddingTop: 32
        }} data-id="element-56" data-mp="2dmo4om0ghlj8">
            <div className="flex-1 w-px" style={{
            background: 'linear-gradient(to bottom, transparent, rgba(200,168,112,0.3))',
            minHeight: 48
          }} data-id="element-57" data-mp="1yqghdctr43zq" />
            <div className="flex-shrink-0 flex flex-col items-center justify-center rounded-full" style={{
            width: 48,
            height: 48,
            border: '1px solid rgba(200,168,112,0.35)',
            background: 'rgba(200,168,112,0.05)'
          }} data-id="element-58" data-mp="3t00popap8tg5">
              <span className="text-[#C8A870] leading-none" style={{
              fontSize: 14,
              fontFamily: 'sans-serif',
              fontWeight: 700
            }} data-id="element-59" data-mp="1tyoh3my7cxoh">21</span>
              <span className="text-[#C8A870] uppercase leading-none tracking-[0.08em]" style={{
              fontSize: 7,
              fontFamily: 'sans-serif',
              fontWeight: 600,
              marginTop: 1
            }} data-id="element-60" data-mp="1jy4eogyy5n4o">días</span>
            </div>
            <div className="flex-1 w-px" style={{
            background: 'linear-gradient(to bottom, rgba(200,168,112,0.3), transparent)',
            minHeight: 48
          }} data-id="element-61" data-mp="167j197s9i5e6" />
          </div>

          {/* Columna DESPUÉS */}
          <div data-id="element-62" data-mp="w8js7o3l47qn">
            <p className="uppercase tracking-[0.22em] text-[#C8A870] mb-4 pb-3" style={{
            fontSize: 10,
            fontFamily: 'sans-serif',
            fontWeight: 600,
            borderBottom: '0.5px solid rgba(200,168,112,0.2)'
          }} data-id="element-63" data-mp="w93c3acsp67b">
              Después
            </p>
            <motion.ul initial="hidden" whileInView="visible" viewport={{
            once: true,
            amount: 0.2
          }} className="space-y-9" data-id="element-64" data-mp="m43ccuq3uqmu">
              {despues.map((item, i) => <motion.li key={i} custom={i} variants={itemVariants} className="flex gap-2.5" data-id="element-65" data-mp="w2swyv9dyp6s" data-mpi={i}>
                  <span className="flex-shrink-0 text-[#C8A870] mt-0.5 select-none" style={{
                fontSize: 14,
                lineHeight: 1.5,
                fontFamily: 'sans-serif'
              }} data-id="element-66" data-mp="3umiz95vlcbkj">—</span>
                  <div data-id="element-67" data-mp="8coq8f0wi9bk">
                    <p className="font-body text-[#F0E8D8]/85 leading-[1.5]" style={{
                  fontSize: 'clamp(12px, 2.2vw, 14px)'
                }} data-id="element-68" data-mp="8cf08rfuw25v">
                      <strong className="font-semibold text-[#F0E8D8]" data-id="element-69" data-mp="3bu70su825ufo">{item.bold}</strong>
                      <br data-id="element-70" data-mp="3gt1jlw60zizs" />{item.light}
                    </p>
                  </div>
                </motion.li>)}
            </motion.ul>
          </div>
        </motion.div>

        {/* Transición de identidad */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.9,
        delay: 0.2
      }} className="mt-20 md:mt-28 max-w-md mx-auto text-center" data-id="element-71" data-mp="33tr8kdschjs4">
          {/* Ajuste 1: opacidad subida de /40 a /65 para legibilidad en móvil con brillo bajo */}
          <p className="font-display italic text-[#F0E8D8]/65 leading-[1.5]" style={{
          fontSize: 'clamp(16px, 3.2vw, 21px)'
        }} data-id="element-72" data-mp="2kx97v6viq9jq">
            “Lo que antes funcionaba,<br data-id="element-73" data-mp="2usksu6xisczx" />hoy ya no alcanza.”
          </p>

          <div className="flex flex-col items-center my-7 gap-0.5" data-id="element-74" data-mp="f2galxoikngs">
            <div className="w-px" style={{
            height: 28,
            background: 'linear-gradient(to bottom, rgba(200,168,112,0.15), rgba(200,168,112,0.55))'
          }} data-id="element-75" data-mp="f0n2sf25zx77" />
            <span className="text-[#C8A870]" style={{
            fontSize: 18,
            lineHeight: 1
          }} data-id="element-76" data-mp="hm4mlkxi0lv8">↓</span>
          </div>

          <p className="font-display font-semibold text-[#F0E8D8] leading-[1.2] mb-4" style={{
          fontSize: 'clamp(24px, 5.5vw, 36px)'
        }} data-id="element-77" data-mp="mjmo4q96ryt7">
            No se trata de volver atrás.
          </p>
          <p className="font-display italic text-gradient-gold leading-[1.25]" style={{
          fontSize: 'clamp(20px, 5vw, 32px)'
        }} data-id="element-78" data-mp="10ddz832kfqr1">
            Se trata de encontrar una estrategia<br data-id="element-79" data-mp="15ebd43gjlymq" />que tenga sentido para esta etapa.
          </p>

          <div className="mx-auto mt-10 mb-7" style={{
          width: 48,
          height: '0.5px',
          background: 'rgba(200,168,112,0.35)'
        }} data-id="element-80" data-mp="rkainlwmixs6" />

          <p className="font-display italic text-[#C8A870]/70 leading-[1.6]" style={{
          fontSize: 'clamp(14px, 2.8vw, 18px)'
        }} data-id="element-81" data-mp="1jbq4hdqcwghc">
            Y eso es exactamente<br data-id="element-82" data-mp="1o4t2pz62we3v" />lo que vas a encontrar acá.
          </p>
        </motion.div>

      </div>
    </section>;
}